export default __webpack_public_path__ + "static/media/alamo-arte-3.017f12ff.webp";